import { loadingSpinner } from './common';
import common from './common';

const $spinner = loadingSpinner();

const $ = jQuery;

if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function (valueToFind, fromIndex) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      var len = o.length >>> 0;

      if (len === 0) {
        return false;
      }

      var n = fromIndex | 0;

      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return (
          x === y ||
          (typeof x === 'number' &&
            typeof y === 'number' &&
            isNaN(x) &&
            isNaN(y))
        );
      }

      while (k < len) {
        if (sameValueZero(o[k], valueToFind)) {
          return true;
        }
        k++;
      }

      return false;
    },
  });
}

export default class BuyNow {
  constructor() {
    this.$buyNowBtn = $('.buy-now');
    this.$buyNowPopUp = null;
    this.$buyNowPopUpOverlay = null;
    this.nodeId = this.getNodeId();
    this.productData = [];
    this.filteredProductData = [];
    this.headerTitleHtml = this.getHeaderTitleHtml();
    this.buyNowTermsHtml = this.getBuyNowTermsHtml();
    this.retailersArr = [];
    this.specsArr = [];
    this.textAll = '全部';
    this.retailerTitle = '零售商';
    this.specTitle = '规格';
    this.filter = {
      retailer: '',
      spec: '',
    };
  }
  // TODO: Add nodeId to twig and get it directly
  getNodeId() {
    const $body = $('body.node--type-illumina-product');
    if (!$body.length) return false;
    const bodyClasses = $body.attr('class').split(/\s+/);
    for (let i in bodyClasses) {
      const c = bodyClasses[i];
      if (c.length > 10 && c.substring(0, 10) === 'page-node-') {
        return parseInt(c.substring(10), 10);
      }
    }
    return false;
  }
  getHeaderTitleHtml()  {
    return $('.field--name-field-information .main-title').html()
  }
  getBuyNowTermsHtml() {
    return $('.buynow-terms').html()
  }
  filterProduct() {
    this.filteredProductData = this.productData.filter(product => 
        this.filter.retailer ? product.name_retailer === this.filter.retailer : true);
    this.filteredProductData = this.filteredProductData.filter(product => 
        this.filter.spec ? product.specification === this.filter.spec : true);
  }
  loading() {
    if (!this.$buyNowPopUpOverlay) {
      $('body').append('<div class="buy-now-pop-overlay"></div>');
    }
    this.$buyNowPopUpOverlay = $('.buy-now-pop-overlay');
    $spinner.removeClass('close');
  }
  dismissLoading() {
    $spinner.addClass('close');
  }
  bindEvent() {
    // bind event for clicking buynow
    this.$buyNowBtn.on('click', () => {
      this.loading();
      $.get( `/illuminate/product/${this.nodeId}/series`, (data) => {
        this.productData = data.length ? data : [];
        this.productData.forEach((product) => {
          const { name_retailer, specification } = product;
          if (!this.retailersArr.includes(name_retailer)) {
            this.retailersArr.push(name_retailer);
          }
          if (!this.specsArr.includes(specification)) {
            this.specsArr.push(specification);
          }
        });
        this.filteredProductData = [ ...this.productData ];
        this.render();
      });
    });

    // bind event for clicking close
    $('body').on('click', '.buy-now-pop-header .close, .buy-now-pop-overlay', () => {
      this.$buyNowPopUp.addClass('closed');
      this.$buyNowPopUpOverlay.addClass('closed');
      $('body').removeClass('modal-open');
      this.dismissLoading();
      this.productData = [];
      this.filteredProductData = [];
      this.filter = {
        retailer: '',
        spec: '',
      };
    });

    // bind event for filtering
    $('.touchevents').on('click', '.filter-by-retailer, .filter-by-spec', (event) => {
      const span = event.target;
      const $ul = $(event.currentTarget).find('ul');
      $(event.currentTarget)
        .parent()
        .find('div')
        .not(`.${event.currentTarget.className}`)
        .find('ul')
        .hide();
      if (span.tagName.toLowerCase() !== 'li') {
        $ul.toggle();
      }
    });
    $('body').on('click', '.buy-now-pop-header li', (event) => {
      const $li = $(event.currentTarget);
      const $ul = $li.parent('ul');
      const filterName = $li.text();
      const $div = $ul.parent('div');
      if ($div.hasClass('filter-by-retailer')) {
        this.filter.retailer = filterName === this.textAll ? '' : filterName;
      } else {
        this.filter.spec = filterName === this.textAll ? '' : filterName;
      }
      $ul.hide();
      $div.find('span').text(filterName);
      this.filterProduct();
      this.render(true);
    });

    // bind event for clearing filter
    $('body').on('click', '.buy-now-pop-header .clear-filter', (event) => {
      this.filter = {
        retailer: '',
        spec: '',
      };
      this.filterProduct();
      this.render(true);
      this.$buyNowPopUp.find('.buy-now-pop-header .filter-by-retailer span').html(this.retailerTitle);
      this.$buyNowPopUp.find('.buy-now-pop-header .filter-by-spec span').html(this.specTitle);
    });
  }
  generateProductHtml() {
    return `${ this.filteredProductData.map(product => 
              `<div class="product-item" data-retailer="${ product.name_retailer }" data-spec="${ product.specification }">
                <div class="thumbnail-wrapper">
                  <img src="${ product.thumbnail }">
                  <div class="spec">
                    <span class="spec-title">${ this.specTitle }</span>
                    <span class="spec-detail">${ product.specification }</span>
                    <img src="${ product.thumbnail_retailer }" class="mb ${ product.name_retailer === '天猫' ? 'tmall' : '' }">
                  </div>
                </div>
                <div class="retailer-wrapper ${ product.name_retailer === '天猫' ? 'tmall' : '' }">
                  <img src="${ product.thumbnail_retailer }" class="pc">
                  <a href="${ product.mobile_link }" class="mb" target="_blank">
                    <img src="/themes/custom/illuma/src/images/buynow.png">
                  </a>
                  <a href="${ product.pc_link }" class="pc" target="_blank">
                    <img src="/themes/custom/illuma/src/images/buynow.png">
                  </a>
                </div>
              </div>`).join('')
            }`
  }
  generateHtml() {
    return  `<div class="buy-now-pop-header">${ this.headerTitleHtml }
                <span class="close">&times;</span>
                <div class="filter">
                  <div class="count"><span>${ this.filteredProductData.length }</span>条</div>
                  <div class="filter-by-retailer">
                    <span>${ this.retailerTitle }</span>
                    <ul>
                      <li>${ this.textAll }</li>
                      ${ this.retailersArr.map(retailer => `<li>${ retailer }</li>`).join('') }
                    </ul>
                  </div>
                  <div class="filter-by-spec">
                    <span>${ this.specTitle }</span>
                    <ul>
                      <li>${ this.textAll }</li>
                      ${ this.specsArr.map(spec => `<li>${ spec }</li>`).join('') }
                    </ul>
                  </div>
                  <div class="clear-filter">
                    清除全部
                  </div>
                </div>
             </div>
            <div class="buy-now-pop-content">
              <div class="no-result">
                暂无查询结果，敬请期待
              </div>
              ${ this.generateProductHtml() }
            </div>
            <div class="buy-now-pop-footer">${ this.buyNowTermsHtml }</div>`;
  }
  calculateBototmPx() {
    const pcWidth = 768;
    const screenWidth = window.innerWidth;
    if (screenWidth < pcWidth) {
      const popFooterHeight = $('.buy-now-pop-footer').outerHeight();
      const $popContent = $('.buy-now-pop-content');
      $popContent.css('bottom', popFooterHeight);
    }
  }
  /**
   * @param {boolean} productOnly - weather to render whole or product only
   */
  render(productOnly) {
    // check if popup wrapper exists
    if (!this.$buyNowPopUp) {
      // create popup wrapper and append to body
      $('body').append('<div class="buy-now-pop"></div>');
      this.$buyNowPopUp = $('.buy-now-pop');
    }
    if (productOnly) {
      const { retailer, spec } = this.filter;
      this.$buyNowPopUp.find('.no-result').removeClass('show');
      if (!retailer && !spec) {
        this.$buyNowPopUp.find('.buy-now-pop-content .product-item')
          .removeClass('hide')
          .removeClass('filtered-last-child')
      } else {
        // hide all first
        this.$buyNowPopUp.find(`.buy-now-pop-content .product-item`).addClass('hide')
          .removeClass('filtered-last-child');
        // show coresponding ones
        this.$buyNowPopUp.find(`.buy-now-pop-content .product-item${ spec && `[data-spec="${ spec }"]`}${ retailer && `[data-retailer="${ retailer }"]` }`).removeClass('hide');
        this.$buyNowPopUp.find('.buy-now-pop-content .product-item:visible').last().addClass('filtered-last-child');
      }
      if (!this.filteredProductData.length) {
        this.$buyNowPopUp.find('.no-result').addClass('show');
      }
      this.$buyNowPopUp.find('.buy-now-pop-header .count span').html(this.filteredProductData.length);
    } else {
      this.$buyNowPopUp.removeClass('closed')
        .html(this.generateHtml());      
      this.$buyNowPopUpOverlay.removeClass('closed');
      $('body').addClass('modal-open');     
      if (!this.filteredProductData.length) {
        this.$buyNowPopUp.find('.no-result').addClass('show');
      }
      this.calculateBototmPx();
    }
  } 
  init() {
    this.bindEvent();
    $(window).resize(this.calculateBototmPx);
  }
}
